import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ConfigValueType, RemoteConfigService} from '../../services/remote-config.service';

@Component({
    selector: 'app-payments-view',
    templateUrl: './payments-view.component.html',
    styleUrls: ['./payments-view.component.scss']
})
export class PaymentsViewComponent implements OnInit, OnChanges {

    @Input() payments: any[] = [];
    @Input() morePayments = false;
    @Input() checkedPayment: any;
    public paymentIdentifier = '';

    @Input() setDefaultOnTap = false;

    @Input() inExpressMode = false;

    @Output() notifyPaymentSelected = new EventEmitter<any>();
    @Output() notifyPaymentRemoved = new EventEmitter<any>();
    @Output() notifyAddPayment = new EventEmitter<any>();

    public otherPaymentSelected = false;

    constructor(
        private remoteConfigService: RemoteConfigService,
    ) {}

    ngOnInit() {
        this.remoteConfigService
            .getConfigValue('terminal_payment_state', ConfigValueType.Boolean)
                .subscribe(
                    (value: boolean) => { this.morePayments = value; },
                    error => { console.error(error); }
                );
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.checkedPayment) {
            this.checkedPayment = changes.checkedPayment.currentValue;
        }
    }

    onSelectedPayment(
        type = '',
        payment: any,
        isThirdPayment = false,
    ): void {
        this.paymentIdentifier = type;
        this.otherPaymentSelected = isThirdPayment;
        this.checkedPayment = payment;
        this.notifyPaymentSelected.emit(payment);
    }

    onDeletedPayment(event: any): void {
        this.notifyPaymentRemoved.emit(event);
    }

    onAddNewPayment(): void {
        this.notifyAddPayment.emit(true);
    }
}
